import { GetValue } from "@shared/components/table-implementation/types/column/column-data-display.type";

export namespace TypeSafeJson {
  // eslint-disable-next-line @tseslint/no-unnecessary-type-parameters
  export function deserialize<ParseOutput> (json: string): ParseOutput;
  export function deserialize<ParseOutput, Computed> (json: string, parse: GetValue<ParseOutput, Computed>): Computed;
  export function deserialize<ParseOutput, Computed> (json: string, parse?: GetValue<ParseOutput, Computed>): ParseOutput | Computed {
    const value = JSON.parse(json) as ParseOutput;

    return parse ? parse(value) : value;
  }

  export function serialize (object: unknown): string {
    return JSON.stringify(object);
  }
}
